import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { forgetReturnPath } from './returnPath';

/**
 * A sign-out the user chose. `App` renders the sign-in screen in place, and sign-in returns to the
 * URL it was shown on, so without leaving the page the next person on this tab would land where the
 * last one was. Session expiry calls `logout` directly instead: that user is coming straight back,
 * possibly mid-SSO, and should keep their page. A tab signing out by choice is signed in, so no SSO
 * round trip is under way and a remembered page left over from an abandoned one is dropped.
 *
 * `logout` runs before `navigate`: the other order would render the dashboard once more under the
 * departing session and fire its requests.
 */
export function useSignOut(): () => void {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return useCallback(() => {
    logout();
    forgetReturnPath();
    navigate('/dashboard', { replace: true });
  }, [logout, navigate]);
}
